import { render } from "./App.vue?vue&type=template&id=b2f2817a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=b2f2817a&lang=less"

import exportComponent from "../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_6d3c9c09aad288fc51dc75b5c4e5d068/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__